<template>
  <div class="login-form" v-show="showLogin">
    <div class="form-header">
      <p>密码登录</p>
      <div class="form-weixin">
        <div class="go-weixin">APP扫码登录</div>
        <img src="@/assets/img/login/QR-code.png" alt @click.prevent="showQrcodeBox" />
      </div>
    </div>
    <div class="form-body">
      <div class="form-group" v-show="showMsg">
        <div>
          <img src="@/assets/img/login/wt.png" alt />
          <span v-text="msgText"></span>
        </div>
      </div>
      <div class="form-group" :class="{ titleMar: !showMsg }">
        <input type="text" class="form-input" autocomplete="off" onfocus="this.removeAttribute('readonly');" readonly
          v-model="form.username" placeholder="维护大师用户名" />
      </div>
      <div class="form-group" style="position: relative;">
        <input type="password" class="form-input" ref="inp2" autocomplete="off"
          onfocus="this.removeAttribute('readonly');" readonly v-model.trim="form.password" maxlength="16"
          placeholder="请输入密码" @keyup.enter="getUsername" />
        <span class="forget" @click.prevent="toReset">忘记密码？</span>
      </div>
      <sliderUnlock ref="sliderUnlock" :l="50" :r="10" :w="260" :h="116" :block_y="block_y" :imgurl="imgurl"
        :miniimgurl="miniimgurl" @success="slideLeftVal"></sliderUnlock>
      <div class="form-group" style="display:flex" v-show="
        ($Cookie.getCookie('username') != form.username && form.username) ||
          !$Cookie.getCookie('uuId') ||
          showSms
      ">
        <input type="text" class="form-inputcode" v-model="form.smsCode" placeholder="请输入验证码"
          @keyup.enter="getUsername" />
        <button class="form-buttoncode" v-show="show" @click.prevent="getLoginCode">
          获取验证码
        </button>
        <button class="form-buttoncode" v-show="!show">{{ count }} s</button>
      </div>
      <div class="form-group">
        <button class="form-button blue-btn" @click.prevent="getUsername">
          登录
        </button>
      </div>
      <p class="p-footer">
        <input type="checkbox" v-model="remember" />
        <span class="remember">记住密码</span>
        其他登录方式：
        <img src="@/assets/img/icon/u284.png" alt @click.prevent="showWxLogin" />
        <span @click.prevent="showRegisteredForm" style="color: rgb(171, 173, 174)">前往注册</span>
      </p>
    </div>
    <div style="margin-left: -40px;">v3版维护大师入口：<a href="https://zhiweicloud.com" class="mainCol f14 fw">https://zhiweicloud.com</a></div>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js' // 加密js
import { getLoginSms, getLogin, getDragImage } from '@/requests/user'
import sliderUnlock from './sliderUnlock'
import { mapActions } from 'vuex'
export default {
  components: {
    sliderUnlock,
  },
  props: {
    showLogin: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showMsg: false,
      msgText: '',
      showCode: false,
      show: true,
      count: '',
      timer: null,
      form: {
        username: '',
        password: '',
        smsCode: '',
      },
      showSms: false,
      remember: false,
      imgurl: '',
      miniimgurl: '',
      block_y: 0,
    }
  },
  watch: {
    showLogin () {
      if (this.showLogin) {
        this.form.username = this.$Cookie.getCookie('username')
        if (this.$Cookie.getCookie('password')) {
          this.form.password = CryptoJS.AES.decrypt(
            this.$Cookie.getCookie('password'),
            'secret key 123'
          ).toString(CryptoJS.enc.Utf8)
          this.remember = true
        } else {
          this.form.password = ''
          this.remember = false
        }
      }
    },
  },
  methods: {
    ...mapActions(['user/actionSetStatement']),
    async getDragImage () {
      this.imgurl = ''
      this.miniimgurl = ''
      this.block_y = 0
      let res = await getDragImage()
      if (res.code == 200) {
        this.imgurl = 'data:image/png;base64,' + res.data.bigImg
        this.miniimgurl = 'data:image/png;base64,' + res.data.smallImg
        this.block_y = Number(res.data.location_y)
        if (this.$refs.sliderUnlock) {
          this.$refs.sliderUnlock.reset(res.data.location_y)
        }
      } else {
        /* eslint-disable */
        console.log(res.msg)
      }
    },
    showQrcodeBox () {
      this.$emit('showQrcodeBox')
    },
    showWxLogin () {
      this.$emit('showWxLogin')
    },
    showRegisteredForm () {
      this.$emit('showRegisteredForm')
    },
    toReset () {
      this.$router.push({
        path: this.$PAGE_API.reset.path,
      })
    },
    async getLoginCode () {
      this.getDragImage()
      this.$refs.sliderUnlock.slideShow = true
    },
    async getUsername () {
      if (this.form.username == '')
      {
        this.msgText = '通行证账号不能为空'
        this.showMsg = true
        return false
      }
      if (this.form.password == '')
      {
        this.msgText = '密码不能为空'
        this.showMsg = true
        return false
      }
      if (this.form.smsCode == '' &&this.$Cookie.getCookie('uuId') == '' )
      {
        this.msgText = '短信验证码不能为空'
        this.showMsg = true
        return false
      }
      let obj = {
        username: this.form.username,
        password: encodeURIComponent(this.form.password),
        smsCode: this.form.smsCode,
        uuid: this.$Cookie.getCookie('uuId'),
      }
      let res = await getLogin(obj)
      if (res.code == 200)
      {
        this['user/actionSetStatement'](1)
        if (res.data)
        {
          if (this.$Cookie.getCookie('uuId'))
          {
            this.$Cookie.delCookie('uuId')
          }
          if (this.$Cookie.getCookie('username'))
          {
            this.$Cookie.delCookie('username')
          }
          if (this.$Cookie.getCookie('txt'))
          {
            this.$Cookie.delCookie('txt')
          }
          this.$Cookie.setCookie('uuId', res.data)
          this.$Cookie.setCookie('txt', this.form.password)
          this.$Cookie.setCookie('username', this.form.username)
        }
        if (this.remember)
        {
          this.$Cookie.setCookie(
            'password',
            CryptoJS.AES.encrypt(this.form.password, 'secret key 123')
          )
        } else
        {
          if (this.$Cookie.getCookie('password'))
          {
            this.$Cookie.delCookie('password')
          }
        }
        window.timeOutLoginQr()
        if (
          window.location.href.split('val=').length > 1 &&
          window.location.href.split('val=')[1] == '1'
        )
        {
          this.$router.push({
            path: this.$PAGE_API.home.children.VIPInfo.path,
          })
        } else if (
          window.location.href.split('val=').length > 1 &&
          window.location.href.split('val=')[1] == '2'
        )
        {
          this.$router.push({
            path: this.$PAGE_API.home.path + '?val=2',
          })
        } else
        {
          this.$router.push({
            path: this.$PAGE_API.home.path,
          })
        }
      } else if (res.code == 201)
      {
        this.$Cookie.delCookie('uuId')
        this.$Cookie.delCookie('username')
        if (this.$Cookie.getCookie('password'))
        {
          this.$Cookie.delCookie('password')
        }
        this.msgText = res.msg
        this.showMsg = true
        this.showSms = true
      } else if (res.code == 401)
      {
        this.msgText = res.msg
        this.showCode = true
        this.showMsg = true
      } else
      {
        this.msgText = res.msg
        this.showMsg = true
        this.showCode2 = true
      }
    },
    async slideLeftVal (val) {
      let obj = {
        passportName: this.form.username,
        imgCode: val,
        pwd: encodeURIComponent(this.form.password),
      }
      let res = await getLoginSms(obj)
      if (res.code == 200)
      {
        this.showMsg = false
        this.countDown()
        this.$refs.sliderUnlock.errorMsg = ''
        this.$refs.sliderUnlock.slideShow = false
      } else if (res.code == 202)
      {
        this.$refs.sliderUnlock.slideShow = false
        this.showMsg = true
        this.msgText = res.msg
      } else
      {
        this.getDragImage()
        this.showMsg = true
        this.$refs.sliderUnlock.slideShow = false
        this.msgText = res.msg
      }
    },
    //验证码倒计时
    countDown () {
      const TIME_COUNT = 60
      if (!this.timer)
      {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT)
          {
            this.count--
          } else
          {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.login-form,
.register-form {
  padding: 20px 30px;
  width: 380px;
  border-radius: 3px;
  background-color: #fff;
  // backface-visibility: hidden;
}

// 表单头部
.form-header {
  display: flex;
  justify-content: space-between;

  p {
    font-size: 20px;
    font-weight: bold;
  }

  .form-weixin {
    display: flex;

    .go-weixin {
      padding-left: 8px;
      transform: translateX(5px);
      width: 96px;
      height: 28px;
      background: url(../../assets/img/login/wx.png) no-repeat;
      color: #00c2de;
      line-height: 28px;
      font-weight: bold;
      text-align: left;
    }

    img {
      cursor: pointer;
    }

    img:hover {
      opacity: 0.8;
      transition: opacity 0.2s;
    }
  }
}

// 表单主体
.form-body {
  .form-group {
    width: 100%;
    padding: 10px 0;

    div {
      overflow: hidden;
      width: 100%;
      line-height: 29px;
      background-color: #fdfae6;
      border: 1px solid #ff934c;
      color: #8c8b85;
      text-align: left;

      img {
        float: left;
        margin: 5px 10px;
      }
    }

    // 表单输入框
    .form-input {
      padding-left: 10px;
      // width: 96.5%;
      width: 100%;
      height: 40px;
      border: 1px solid #dcdcdc;
      color: #000;
      outline: none;
      transition: all 0.7s;
    }

    .form-input:focus {
      border: 1px solid #00c2de;
    }

    // 表单按钮
    .form-button {
      width: 100%;
      height: 40px;
      border: none;
      outline: none;
      color: #fff;
      background-color: #0099cc;
      transition: background-color 0.3s;
    }

    .form-button:hover {
      background-color: #28b5d6;
    }

    .form-button:active {
      background-color: #00ccff;
    }

    // 获取验证码输入框
    .form-inputcode {
      padding-left: 10px;
      // width: 69%;
      width: 70%;
      height: 42px;
      border: 1px solid #00c6de;
      color: #000;
      background-color: #ddf8fc;
    }

    // 获取验证码按钮
    .form-buttoncode {
      // width: 29%;
      width: 30%;
      height: 42px;
      border: 1px solid #00c6de;
      background-color: #ddf8fc;
      border-left: none;
      color: #20c6e0;
    }

    .forget {
      position: absolute;
      top: 25px;
      right: 20px;
      // transform: translate(90px, -30px);
      color: rgb(0, 153, 204);
      cursor: pointer;
    }
  }

  // 表单底部
  p {
    color: #abadae;
    text-align: right;

    a:hover {
      color: #00c2de;
    }
  }

  .span {
    position: absolute;
    top: 460px;
    margin-bottom: 30px;
    line-height: 20px;
    font-size: 14px;
    color: #00c2de;
    text-align: left;
    cursor: pointer;
  }

  .p-footer {
    line-height: 70px;
    color: #abadae;
    text-align: left;
    font-size: 12px;

    input {
      position: relative;
      top: 3px;
      background: #fff;
      cursor: pointer;
    }

    .remember {
      margin: 0 20px 0 5px;
      float: none;
      color: #abadae;
    }

    img {
      position: absolute;
      width: 20px;
      transform: translate(10px, 25px);
      cursor: pointer;
    }

    img:last-child {
      transform: translate(45px, 27px);
    }

    span {
      float: right;
      color: rgb(0, 153, 204);
      font-size: 12px;
      font-weight: inherit;
      cursor: pointer;
    }
  }
}

.titleMar {
  margin-top: 50px;
}

.btnMar {
  margin-top: 64px;
}

.img-code {
  position: absolute;
  top: 360px;
  right: 10px;
  width: 140px;
  height: 95px;
}
</style>
